import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Layer, Loading } from '@folio/stripes-components';
import { useHistory } from 'react-router-dom';
import WizardForm from '../../../../shared/WizardForm';
import TemplateFormPages from './pages';
import css from '../../../../shared-styles/sharedStyles.css';
import ImportTemplate from '../ImportTemplate';

function TemplateBuilder({
  initialValues,
  onSubmit,
  paneTitle,
  isLoading = false,
}) {
  const [importedValues, setImportedValues] = useState(undefined);
  const history = useHistory();

  return (
    <Layer contentLabel="Inventory template wizard form" isOpen>
      {isLoading && (
        <div className={css.loading}>
          <Loading size="xlarge" />
        </div>
      )}
      {!isLoading && (
        <WizardForm
          initialValues={importedValues || initialValues}
          onSubmit={onSubmit}
          pages={TemplateFormPages}
          onClose={() => history.go(-1)}
          lastMenu={<ImportTemplate setInitialValues={setImportedValues} />}
          paneTitle={paneTitle}
          formId="inventory-templates-plugin-create-template"
        >
          {TemplateFormPages.map((page) => (
            <WizardForm.Page key={page.id}>
              <page.contenet />
            </WizardForm.Page>
          ))}
        </WizardForm>
      )}
    </Layer>
  );
}

TemplateBuilder.propTypes = {
  initialValues: PropTypes.arrayOf(PropTypes.object),
  onSubmit: PropTypes.func,
  paneTitle: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default TemplateBuilder;
